import { render, staticRenderFns } from "./Log.vue?vue&type=template&id=06bc1f3a&scoped=true&"
import script from "./Log.vue?vue&type=script&lang=js&"
export * from "./Log.vue?vue&type=script&lang=js&"
import style0 from "./Log.vue?vue&type=style&index=0&id=06bc1f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc1f3a",
  null
  
)

export default component.exports